import { css } from 'styled-components';

export const pickerLabelStyles = css`
  font-size: 20px;
  padding-bottom: 5px;
`;

export const hiddenInputStyles = css`
  display: none;
`;

export const pickerContainerStyles = css`
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: flex-end;
`;

export const nonRequiredStyles = css`
  float: right;

  @media only screen and (max-width: 400px) {
    margin-inline-end: 10px;
  }
`;
export const separatorStyles = css`
  width: 30%;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
  margin-inline-start: 10px;
  margin-inline-end: 20px;
  margin-block-end: 13px;

  @media only screen and (max-width: 400px) {
    display: none;
  }
`;

export const datePickerContainerStyles = css`
  width: 40%;
  text-align: start;

  @media only screen and (max-width: 400px) {
    margin-inline-end: 20px;
  }
`;

export const timePickerContainerStyles = css`
  width: 20%;
  text-align: start;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;

  @media only screen and (max-width: 400px) {
    margin-inline-start: 20px;
  }
`;

export const customTimeInputStyles = css`
  padding: 12px 10px 12px 10px;
  width: 100%;
  transition: 0.4s box-shadow ease;
  border: 1px solid #7E7E7E;
  border-radius: 6px;
`;

export const customDateInputStyles = css`
  transition: 0.4s box-shadow ease;
  border: 1px solid #7E7E7E;
  border-radius: 6px;
  padding: 12px 10px 12px 10px;
`;

export const iconCSS = css`
  position: absolute;
  inset-inline-end: 1em;
  top: 0.55em;

  @media only screen and (min-width: 650px) (max-width: 1050px) {
    top: 0.7em;
  }

  @media only screen and (max-width: 649px) {
    top: 0.8em;
    right: 0.5em;
  }
`;

const sharedPickerStyles = css`
  .react-datepicker-wrapper {
    .react-datepicker__input-container {
      label {
        div[class^='TimeSlotPicker'] {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }

  .react-datepicker__aria-live {
    display: none;
  }

  @media only screen and (max-width: 300px) {
    .icon {
      display: none;
    }
  }
`;

export const datePickerStyles = css`
  ${sharedPickerStyles}

  justify-content: flex-start;
  display: flex;

  .react-datepicker {
    &__header {
      background-color: #fff;
    }
    &__day:hover {
      border-radius: 25px !important;
    }

    &__day--keyboard-selected,
    &__day--selected {
      border-radius: 25px !important;
      background-color: #009900 !important;
      color: #000 !important;
    }
  }

  .react-datepicker__day--outside-month {
    color: transparent !important;
    pointer-events: none;
    background-color: transparent !important;
  }

  .react-datepicker-popper[data-placement^='bottom'] { 
    z-index: 5;
  }
  
  .react-datepicker__day.react-datepicker__day--keyboard-selected { 
    background: none !important; 
    color: black !important;
  }

  .react-datepicker__day--disabled.react-datepicker__day--keyboard-selected {
    color: #ccc !important;
  }
`;

export const timePickerStyles = css`
  ${sharedPickerStyles}

  .react-datepicker {
    &__header {
      background-color: #fff;
    }
    &__time-list-item--selected {
      background: #ebebeb !important;
      color: #000 !important;
    }
  }
`;
